import Loader from "./loader";
import MenuEvents from "./menu-events";
import Slider from './slider';

// Load application
window.onload = () => {
  /**
   * Menu and Window events
   */
  MenuEvents.setBurgerMenuWhenMobile();
  MenuEvents.scrollPageEvent();
  MenuEvents.smoothLinkEvent();
  
  /**
   * Sliders
   */
  Slider.init('editions-slider'); // Editions

  // Loader Stop, open site
  Loader.stopLoading();
};
